/**
 * Шапка ленты: что это за платформа и чем она отличается.
 *
 * Стоит там, где раньше была полоса важного. Полоса уехала вниз осознанно:
 * она про сегодняшние события, а человек, открывший приложение впервые,
 * сначала должен понять, куда он попал. Событие без этого понимания — просто
 * мелькающий баннер.
 *
 * Цифры берутся из той же ленты, что уже пришла: обещание «нам можно верить»
 * подкрепляется тем, что прямо сейчас идёт, а не словами о надёжности.
 */
import type { Feed } from '@allswipes/client';
import { num } from '@allswipes/ui';
import { usePlural, useT } from '@allswipes/i18n';

export function FeedHero({ feed }: { feed: Feed }) {
  const plural = usePlural();
  const t = useT();
  const brands = feed.brands?.length ?? 0;
  const regions = feed.regions?.length ?? 0;

  return (
    <section className="fhero">
      <div className="fhero-in">
        {/* Логотип здесь не нужен: он уже стоит в шапке страницы, и второй
            раз на том же экране это не узнавание, а повтор. */}
        <h1 className="fhero-title">{t('Платформа, которая создаёт доверие')}</h1>

        <p className="fhero-sub">
          {t(
            t('Промо-акции брендов, результат которых можно пересчитать самому: победителей определяет формула от публичного сида, а не обещание организатора.'),
          )}
        </p>

        <div className="fhero-facts">
          <span>
            <b>{num(feed.found)}</b> {t(plural(feed.found, t('акция'), t('акции'), t('акций')))}
          </span>
          <i aria-hidden />
          <span>
            <b>{num(brands)}</b> {t(plural(brands, t('бренд'), t('бренда'), t('брендов')))}
          </span>
          <i aria-hidden />
          <span>
            <b>{num(regions)}</b> {t(plural(regions, t('страна'), t('страны'), t('стран')))}
          </span>
        </div>
      </div>
    </section>
  );
}
